import React from 'react';

interface Props {
  day: string;
  month: string;
}

const CalendarIcon: React.FC<Props> = ({ day, month }) => (
  <div className="flex flex-col p-4">
    <div className="py-1 px-6 text-center rounded-t-md rounded-b-sm bg-blue-200 text-white text-base font-semibold">
      {month}
    </div>

    <div className="p-2 px-6 text-center bg-gray-200 rounded-b-md text-black text-lg font-bold">
      {day}
    </div>
  </div>
);

export default CalendarIcon;
